module.exports = __webpack_public_path__ + "static/media/Jae-Min_Jo_resume_2020.4b99d618.pdf";